import FormInput from '@/components/molecules/FormInput';
import { formatNumberWithCommas } from '@/lib/formatNumberWithCommas';
import { isValidFormattedPrice } from '@/lib/isValidFormattedPrice';
import { SearchFilterGeneralProps } from '../SearchFilterGeneralInfoSection/SearchFilterGeneralInfoSection';

export const SearchFilterMileageSection: React.FC<SearchFilterGeneralProps> = ({
  updateFilter,
  filters,
}) => {
  const { maxMileage } = filters;
  return (
    <section className="flex flex-col gap-l pt-s">
      <section>
        <FormInput
          label="Max. Mileage"
          type="text"
          placeholder="100,000 miles"
          value={formatNumberWithCommas(maxMileage)}
          onChange={(value) => {
            const { formattedPrice, isValid } = isValidFormattedPrice(value);
            if (isValid) {
              updateFilter({
                fields: {
                  maxMileage: formattedPrice,
                },
                refetchOnUpdate: false,
              });
            }
          }}
          onBlur={() => {
            const adjustedMileage =
              Number(maxMileage) >= 1 && Number(maxMileage) < 100
                ? '100'
                : maxMileage;
            updateFilter({
              fields: {
                maxMileage: adjustedMileage,
              },
            });
          }}
        />
      </section>
    </section>
  );
};
